// extracted by mini-css-extract-plugin
export default {"dropdown":"popover_dropdown__KTr4I","arrow":"popover_arrow__r01Jo"};